import { render } from "./RNavTop.vue?vue&type=template&id=4bef48e2"
import script from "./RNavTop.vue?vue&type=script&lang=js"
export * from "./RNavTop.vue?vue&type=script&lang=js"

import "./RNavTop.vue?vue&type=style&index=0&id=4bef48e2&lang=css"
script.render = render

export default script